export default {
  path: "/SectionContent/CrashLocation",
  name: "Crash Location",
  htmlContent: "crash_location.html",
  headings: [
    { id: "n3County", text: "3.   County", type: "field" },
    { id: "n13InsideCityOf", text: "13. Inside City Of", type: "field" },
    { id: "n14RoadOfOccurrence", text: "14. Road of Occurrence", type: "field" },
    { id: "n15AtItsIntersectionWith", text: "15. At Its Intersection With", type: "field" },
    { id: "n16NotAtItsIntersectionBut", text: "16. Not At Its Intersection But", type: "field" },
    { id: "n17Of", text: "17. Of", type: "field" },
    { id: "n18Latitude", text: "18. Latitude", type: "field" },
    { id: "n19Longitude", text: "19. Longitude", type: "field" },
  ],
};
